import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import axios from 'axios';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { isEmpty } from '../utils/helper';
import TokenManager from '../utils/TokenManager';
const contentType = 'application/json; charset=UTF-8';
export const fetchURL = function (url) {
  let headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetch(url, Object.assign({}, {
    headers: _objectSpread({
      Accept: contentType,
      'tap-api-token': TokenManager.getItem(TokenManager.accessTokenKey),
      email: TokenManager.getItem('email')
    }, headers)
  }));
};

/**
 * @description Function to process the response based on the response status
 * If response is ok it process the JSON else rejects the Promise
 * @param {Object} - res - JSON response object.
 * @returns {Object} - response - Resolved promise object.
 */
export const processResponse = res => {
  let response = null;
  if (res.ok) {
    response = res.json();
  } else {
    response = Promise.reject(res);
  }
  return response;
};

/**
 * @description Sending a GET request to JSON API.
 * doGet method resolves or rejects the promise that is obtained
 * from the fetchURL method
 * @param {string} url
 * @returns {object}
 */
export const doGet = function (url) {
  let headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetchURL(url, headers).then(res => processResponse(res));
};

/**
* @description Sending a POST request to JSON API.
* doPost method resolves or rejects the promise that is obtained
* from the fetchURL method
* @param {string} url
* @param {object} data
* @param {object} customHeader
* @param {object} tokenInfo
* @returns {object}
*/
export const doPost = function (url, data) {
  let customHeader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let tokenInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EMPTY_OBJECT;
  const header = customHeader || {};
  let dataObj = data;
  if (!customHeader) {
    header['Content-Type'] = contentType;
    dataObj = JSON.stringify(data);
  }
  if (isEmpty(tokenInfo)) {
    header['tap-api-token'] = TokenManager.getItem(TokenManager.accessTokenKey);
  } else {
    const {
      tokenPropertyName = EMPTY_STRING,
      token = EMPTY_STRING
    } = tokenInfo;
    header[tokenPropertyName] = token;
  }
  return fetch(url, Object.assign({}, {
    method: 'POST',
    headers: header,
    body: dataObj
  })).then(res => processResponse(res));
};
export const doAxiosGet = (baseUrl, timeout) => axios.create({
  baseURL: baseUrl,
  timeout: timeout || '0',
  headers: {
    'Content-Type': 'application/json'
  }
})();

/**
* @description Sending a PUT request to JSON API.
* doPut method resolves or rejects the promise that is obtained
* from the fetchURL method
* @param {string} url
* @param {object} data
* @param {object} tokenInfo
* @returns {object}
*/
export const doPut = function (url, data) {
  let tokenInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
  const header = {};
  header['Content-Type'] = contentType;
  if (isEmpty(tokenInfo)) {
    header['tap-api-token'] = TokenManager.getItem(TokenManager.accessTokenKey);
  } else {
    const {
      tokenPropertyName = EMPTY_STRING,
      token = EMPTY_STRING
    } = tokenInfo;
    header[tokenPropertyName] = token;
  }
  const dataObj = JSON.stringify(data);
  return fetch(url, Object.assign({}, {
    method: 'PUT',
    headers: header,
    body: dataObj
  })).then(res => processResponse(res));
};

/**
* @description Sending a DELETE request to API.
* doDelete method resolves or rejects the promise that is obtained
* from the fetchURL method
* @param {string} url
* @param {object} data
* @returns {object}
*/
export const doDelete = url => {
  const header = {};
  header['Content-Type'] = contentType;
  header['tap-api-token'] = TokenManager.getItem(TokenManager.accessTokenKey);
  return fetch(url, Object.assign({}, {
    method: 'DELETE',
    headers: header
  })).then(res => processResponse(res));
};